import { ISignSubjectInfo } from '../interfaces/ISignSubjectInfo';

/**
 * Парсинг информации из сертификата
 */
const parseSubjectName = (str: string) => {
  const regex = /[A-Z]*?=/gm;

  let m;

  const objs: { key: string; value: string; position: number }[] = [];

  // eslint-disable-next-line no-cond-assign
  while ((m = regex.exec(str)) !== null) {
    if (m.index === regex.lastIndex) {
      // eslint-disable-next-line no-plusplus
      regex.lastIndex++;
    }

    m.forEach(key => {
      objs.push({ key, value: '', position: str.indexOf(key) });
    });
  }

  const removeQuotes = (value: string) => {
    if (value[0] === '"' && value[value.length - 1] === '"') {
      return value.substring(1, value.length - 1);
    }

    return value;
  };

  return objs.map((obj, i) => {
    const newObj = obj;

    if (i + 1 < objs.length) {
      newObj.value = str.substring(obj.position + obj.key.length, objs[i + 1].position);

      if (newObj.value[newObj.value.length - 1] === ' ' && newObj.value[newObj.value.length - 2] === ',') {
        newObj.value = newObj.value.substring(0, newObj.value.length - 2);
      }

      newObj.value = removeQuotes(newObj.value);
      newObj.key = newObj.key.replace('=', '');

      return newObj;
    }
    newObj.value = str.substring(obj.position + obj.key.length);
    newObj.value = removeQuotes(newObj.value);
    newObj.key = newObj.key.replace('=', '');

    return newObj;
  });
};

/**
 * Функция извлечения из сертификата ФИО и организации
 */
export const getSubjectInfo = (subjectName: string) => {
  const array = parseSubjectName(subjectName);

  const org = array.find(i => i.key === 'O')?.value;
  const fioSignerCN = array.find(i => i.key === 'CN')?.value;
  const ogrn = array.find(i => i.key === 'OGRN')?.value;
  const sn = array.find(i => i.key === 'SN')?.value;
  const g = array.find(i => i.key === 'G')?.value;
  let fioSigner = '';

  if (sn && g) {
    fioSigner = `${g} ${sn}`;
  }

  return { fioSigner, fioSignerCN, org, ogrn } as ISignSubjectInfo;
};
